import React, { Component } from 'react';
import {
    BarChart, Bar, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    Pie, PieChart, Line, LineChart
} from 'recharts';
import { toast } from "react-toastify";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import './Home.css'
import ComboboxInput from "../pages/PushInteractive/ComboboxInputCustom";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import ActionGetAllSender from '../store/action/Sender/FetchAll'
import { ClientId, SenderId, PrevilageId } from "../helper/HelperAuth";
import hourglass from "../source/hourglass.png";
import ActionGetPushSummary from "../store/action/Home/PushSummaryFetch";
import ActionGetInteractiveSummary from "../store/action/Home/InteractiveSummaryFetch";
import ActionGetTemplateSummary from "../store/action/Home/TemplateSummaryFetch";
import ActionGetAccessModule from '../store/action/AccessModule/Fetch'
import ActionGetClient from '../store/action/Client/FetchAll'
import ActionFindByGroupId from '../store/action/Previlage/FindByGroupId'


class PageHome extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loaderStyle: {},
            dissender: true,
            isadmin:false,
            hideclient:'hide',
            colhide:'col-sm-4',
            form: fromJS({
                'client': ClientId,
                'sender': SenderId,
                'tahun': "",
                'bulan': "",
                'tanggal-mulai': "",
                'tanggal-selesai': ""
            }),
        };

    }

    async componentDidMount() {
        var isAdmin = await this.props.actionFindByGroupId();
        this.setState({isadmin:isAdmin})
	    if (PrevilageId > 1 && isAdmin == false) {
            this.setState({ hideclient: 'hide', colhide: 'cols-sm-8' })
        } else {
            this.setState({ hideclient: '', colhide: 'cols-sm-4' })
        }
        this.props.actionGetClient();
        await this.props.actionGetAccessModule(PrevilageId);
        let restrict = this.handleActionId()
        let dissen = this.state.dissender
        if (restrict == 5) dissen = true
        else dissen = false
        this.setState({ dissender: dissen })
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        this.props.actionGetAllSender(ClientId)
        var body = {
            "sender": SenderId,
            "tahun": year.toString(),
            "bulan": month.toString(),
            "tanggal-mulai": date.toString(),
            "tanggal-selesai": date.toString(),
        }
        this.setState({ loaderStyle: {} })
        var push = await this.props.actionGetPushSummary(body)
        var inter = await this.props.actionGetInteractiveSummary(SenderId, year.toString(), month.toString(), date.toString(), date.toString())
        var template = await this.props.actionGetTemplateSummary(SenderId, year.toString(), month.toString(), date.toString(), date.toString())
        this.setState({ loaderStyle: { display: 'none' } })
    }

    async handleChange(field, value, label) {
        var formVal = this.state.form;
        if (value == null) value = ""
        
		if (field == 'client') {
            this.props.actionGetAllSender(value)
            formVal = formVal.set('sender', '')
        }
        
       if (field == 'sender') {
           if (value == "") {
                toast.warn('Sender cannot be empty');
                return false
            }
            formVal = formVal.set(field, value);

        }
        formVal = formVal.set(field, value);
        this.setState({ form: formVal })
	    if (formVal.get('sender') == '') {
            toast.warn('Sender cannot be empty');
            return false
        }

        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();

        var body = {
            "sender":formVal.get('sender'),
            "tahun": year.toString(),
            "bulan": month.toString(),
            "tanggal-mulai": date.toString(),
            "tanggal-selesai": date.toString(),
        }
        this.setState({ loaderStyle: {} })
        var push = await this.props.actionGetPushSummary(body)
        var inter = await this.props.actionGetInteractiveSummary(value.toString(), year.toString(), month.toString(), date.toString(), date.toString())
        var template = await this.props.actionGetTemplateSummary(value.toString(), year.toString(), month.toString(), date.toString(), date.toString())
        this.setState({ loaderStyle: { display: 'none' } })
    }

    handleActionId() {
        let array = []
        let action = 0;
        let menuPrev = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        {
            menuPrev.map((data, i) =>
                array.push({
                    'menu-name': data.get('menu-name'),
                    'action-id': data.get('action-id')
                })

            )
        }

        for (let i = 0; i < array.length; i++) {
            if (array[i]['menu-name'] === 'Home Dashboard') {
                action = array[i]['action-id'];
                this.state.action_id = array[i]['action-id'];
            }
        }
        return action;
    }

    render() {
        let pushSummary = this.props.homepushsummary
        let interactiveSummaryData = this.props.homeinteractivesummary
        let templateSummaryData = this.props.hometemplatesummary
        const {  form, errors,loaderStyle } = this.state;
        return (
            <div> <div className="page-loader-wrapper" style={loaderStyle}>
                <div className="loader">
                    <div className="preloader">
                        <div className="spinner-layer pl-orange">
                            <div className="circle-clipper left">
                                <div className="circle"></div>
                            </div>
                            <div className="circle-clipper right">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                    <p>Please wait...</p>
                </div>
            </div>
			<div className="content-header">
                    <div className="col-lg-12">
                        <div className="card-header col-lg-10">
                            <div className="">
                                <h1 className="m-0 headplat"><strong>WABAPRO</strong></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="forms-groups cols-sm-3 floats-right">

                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="container-fluid">
                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content-header">
                                    <div className="rows mb-2">
                                        <div className={this.state.colhide}>
                                            <h1 className="titles-card-child">Push Summary</h1>
                                        </div>
                                        <div className= {`forms-groups cols-sm-4 right ${this.state.hideclient}`}>
                                            <div className="col-sm-12 right">
                                                <ComboboxInput
                                                    field='client'
                                                    value={form.get('client')}
                                                    options={fromJS({
                                                        'source': this.props.clientall,
                                                        'value': 'client-id',
                                                        'label': 'client-name'
                                                    })}
                                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
													disabled={this.state.dissender}
                                                    placeholder="Client"
                                                />
                                            </div>

                                        </div>                                        
                                        <div className="forms-groups cols-sm-4 right">
                                            <div className="col-sm-12 right">
                                                <ComboboxInput
                                                    field='sender'
                                                    value={form.get('sender')}
                                                    options={fromJS({
                                                        'source': this.props.senderall,
                                                        'value': 'sender-id',
                                                        'label': 'sender-id-name'
                                                    })}
                                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                                    placeholder="Sender"
                                                    disabled={this.state.dissender}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-xs-2" id="p1">
                                        <div className="small-box blue">
                                            <div className="inner">
                                                <h3>{pushSummary.get('total')}</h3>
                                                <p className='titles-card-child2'>Total Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p2">
                                        <div className="small-box red">
                                            <div className="inner">
                                                <h3>{pushSummary.get('total-sent')}</h3>
                                                <p className='titles-card-child2'>Total Sent Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p3">
                                        <div className="small-box orange">
                                            <div className="inner">
                                                <h3>{pushSummary.get('total-delivered')}</h3>
                                                <p className='titles-card-child2'>Total Delivered Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p4">
                                        <div className="small-box yellow">
                                            <div className="inner">
                                                <h3>{pushSummary.get('total-read')}</h3>
                                                <p className='titles-card-child2'>Total Read Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p5">
                                        <div className="small-box grey">
                                            <div className="inner">
                                                <h3>{pushSummary.get('total-failed')}</h3>
                                                <p className='titles-card-child2'>Total Failed Messages</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content-header">
                                    <div className="rows mb-2">
                                        <div className="cols-sm-12">
                                            <h1 className="m-0 titles-card-child">Interactive Summary</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-2" id="p1">
                                        <div className="small-box orange">
                                            <div className="inner">
                                                <h3>{interactiveSummaryData.get('total-tickets')}</h3>
                                                <p className='titles-card-child4'> Total Tickets</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p3">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{interactiveSummaryData.get('queue-tickets')}</h3>
                                                <p className='titles-card-child3'>Queue Tickets</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p2">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{interactiveSummaryData.get('new-tickets')}</h3>
                                                <p className='titles-card-child3'>New Tickets</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p3">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{interactiveSummaryData.get('onprocess-tickets')}</h3>
                                                <p className='titles-card-child3'>On Process Tickets</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-2" id="p4">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{interactiveSummaryData.get('closed-tickets')}</h3>
                                                <p className='titles-card-child3'>Close Tickets</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="rows">
                            <div className="cols-lg-12">
                                <div className="content-header">
                                    <div className="rows mb-2">
                                        <div className="cols-sm-12">
                                            <h1 className="m-0 titles-card-child">Template Summary</h1>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4" id="p1">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{templateSummaryData.get('total-approved')}</h3>
                                                <p className='titles-card-child3'>Ready</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4" id="p2">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{templateSummaryData.get('total-pending')}</h3>
                                                <p className='titles-card-child3'>Waiting Approval</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-4" id="p3">
                                        <div className="small-box white">
                                            <div className="inner">
                                                <h3>{templateSummaryData.get('total-rejected')}</h3>
                                                <p className='titles-card-child3'>Rejected</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            isLoggedIn: state.auth.isLoggedIn,
            senderall: state.user.senders,
            homepushsummary: state.user.homepushsummary,
            homeinteractivesummary: state.user.homeinteractivesummary,
            hometemplatesummary: state.user.hometemplatesummary,
            accessmodules: state.user.accessmodules,
   			clientall: state.user.clientall,
        }
    },
    dispatch => bindActionCreators({
        actionGetAccessModule: ActionGetAccessModule,
        actionGetAllSender: ActionGetAllSender,
        actionGetPushSummary: ActionGetPushSummary,
        actionGetInteractiveSummary: ActionGetInteractiveSummary,
        actionGetTemplateSummary: ActionGetTemplateSummary,
        actionFindByGroupId:ActionFindByGroupId,
     	actionGetClient: ActionGetClient,
    }, dispatch),
)(PageHome);